import { useCallback, useEffect, useRef, useState } from 'react';
import smoothscroll from 'smoothscroll-polyfill';

const SCROLL_OFFSET = 400;

const SCROLL_DIRECTION_OFFSET = 5;

const SCROLL_OPTIONS = {
  left: 0,
  delay: 0,
  duration: 200,
  behavior: 'smooth',
  animated: true,
};

export default function useScrollMobile(ref) {
  const ts = useRef();
  const [scrollTop, setScrollTop] = useState(0);

  const slideUp = useCallback(() => {
    if (!scrollTop) return;
    smoothscroll.polyfill();
    ref.current.scrollTo({ ...SCROLL_OPTIONS, top: scrollTop - SCROLL_OFFSET });
    setScrollTop(scrollTop - SCROLL_OFFSET);
  }, [scrollTop]);

  const slideDown = useCallback(() => {
    smoothscroll.polyfill();
    ref.current.scrollTo({ ...SCROLL_OPTIONS, top: scrollTop + SCROLL_OFFSET });
    setScrollTop(scrollTop + SCROLL_OFFSET);
  }, [scrollTop]);

  const handleTouchStart = useCallback(
    (event) => {
      ts.current = event?.touches[0].clientY;
    },
    [scrollTop],
  );

  const handleTouchEnd = useCallback(
    (event) => {
      const te = event?.changedTouches[0].clientY;
      const temp = ts.current - te;
      if (ts.current > te + SCROLL_DIRECTION_OFFSET) {
        slideDown(temp);
      } else if (ts.current < te - SCROLL_DIRECTION_OFFSET) {
        slideUp(temp);
      }
    },
    [slideDown, slideUp],
  );

  useEffect(() => {
    ref?.current?.addEventListener('touchstart', handleTouchStart);
    ref?.current?.addEventListener('touchend', handleTouchEnd);

    return () => {
      ref?.current?.removeEventListener('touchstart', handleTouchStart);
      ref?.current?.removeEventListener('touchend', handleTouchEnd);
    };
  }, [handleTouchEnd, handleTouchStart]);
}
